import { 
  DC_LOAD_START,
  DC_LOAD_ABORD,
  DC_LOAD_COMPLETE,
  DC_LOAD_ERROR,
  DC_CANCEL
} from './../actions/actions_ajax'
import { 
  AJAX_STATUS_LOADING,
  AJAX_STATUS_COMPLETE,
  AJAX_STATUS_ABORD,
  AJAX_STATUS_ERROR,
  AJAX_STATUS_CANCEL
} from './../lib/tsaw_ajax'

const initState = {
  dcLoaders: [], // dynamic content loaders
}

export default (state = initState, action) => {
  switch (action.type) {
    case DC_LOAD_START:
      // update status + cancel any other dc load
      return {...state, dcLoaders: [].concat(state.dcLoaders.map(it => ({...it, status: it.status == AJAX_STATUS_LOADING ? AJAX_STATUS_ABORD : it.status})).filter(it => it.id != action.payload.id), {...action.payload, status: AJAX_STATUS_LOADING} )}
    case DC_LOAD_COMPLETE:
      return {...state, dcLoaders: state.dcLoaders.map(it => it.id == action.payload.id ? {...it, status: AJAX_STATUS_COMPLETE} : it)}
    case DC_LOAD_ABORD:
      return {...state, dcLoaders: state.dcLoaders.map(it => it.id == action.payload.id ? {...it, status: AJAX_STATUS_ABORD} : it)}
    case DC_CANCEL:
      return {...state, dcLoaders: state.dcLoaders.map(it => it.id == action.payload.id ? {...it, status: AJAX_STATUS_CANCEL} : it)}
    case DC_LOAD_ERROR:
      return {...state, dcLoaders: state.dcLoaders.map(it => it.id == action.payload.id ? {...it, status: AJAX_STATUS_ERROR} : it)}
    default:
      return state
  }
}